import React, { useEffect, useState } from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import Select from 'antd/lib/select';
import useCurrentUser from '../../../hooks/useCurrentUser';
import UserAvatar from './UserAvatar';
import { Header } from '../styles';
import { IHeaderMenuProps } from '../types';
import PageMenuPJ from "../../PageWrapperPessoaJuridica/components/PageMenuPJ"
import { CompanyOption, readCompanies, readSelectedCompany, selectCompany } from '../../../global/companies';

const HeaderMenu: React.FC<IHeaderMenuProps> = (props: IHeaderMenuProps) => {
  const {
    onSignOutButtonClick,
    collapsed,
    toggle,
    onModalStatus,
  } = props;
  const { name } = useCurrentUser();
  const [empresas, setEmpresas] = useState<Array<CompanyOption>>([]);
  const [selectedCompany, setSelectedCompany] = useState<CompanyOption | null>(null);

  useEffect(() => {
    setEmpresas(readCompanies());
    setSelectedCompany(readSelectedCompany());
  }, []);

  const handleCompanySelected = (id: any) => {
    const company = empresas.find((item) => item.value === id);

    if (!company) return;

    selectCompany(company);
    setSelectedCompany(company);

    // Recarrega em vez de só trocar o estado: cada tela lê a empresa do
    // localStorage na montagem, e sem a volta ao painel metade dos dados na tela
    // continuaria sendo da empresa anterior.
    window.location.assign('/painel-de-vendas');
  };

  return (
    <Header>
      {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
        className: 'trigger',
        onClick: toggle,
      })}
      <div className='pages'><PageMenuPJ/></div>
      {/* Mesmo seletor da área de PJ. A troca de empresa não é privilégio de um
          tipo de conta: quem tem mais de uma vinculada precisa dela em qualquer
          área, e o PF com duas ficava preso na primeira. */}
      {empresas.length > 1 && (
        <Select
          style={{ width: 200 }}
          value={selectedCompany?.value}
          onChange={handleCompanySelected}
          options={empresas}
        />
      )}
      <UserAvatar
        userName={name}
        onSignOutButtonClick={onSignOutButtonClick}
        onModalStatus={onModalStatus}
      />
    </Header>
  );
};

export default HeaderMenu;
